import React, { useContext } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { BetDetailsModalStoreContext } from "@state/context/my-bets/BetDetailsModalStoreContext";
import { useFixBody } from "@state/hooks/shared";
import { ReuseBetSlipStore } from "@state/stores/my-bets/ReuseBetSlipStore";
import { BetDetailsModalStore } from "@state/stores/my-bets/BetDetailsModalStore";

export const BetDetailsReuse = observer(function BetDetailsReuse() {
	const store = useContext(BetDetailsModalStoreContext);
	const t = useTranslation().t;
	useFixBody(false, store?.reuseBetSlipStore.isReuseModalOpen, "reuse-form");

	let reuseStore: ReuseBetSlipStore;

	if (store instanceof BetDetailsModalStore) {
		reuseStore = store.myBetsStore.reuseBetSlipStore;
	} else {
		reuseStore = store.reuseBetSlipStore;
	}

	if (store == null) {
		return null;
	}

	if (!store.isReuseOpen) {
		return null;
	}

	return (
		<div id="reuse-form">
			<div className="popup__header u-padd--reset">
				{t<string>("mybets:REUSE.TITLE")}
			</div>
			<div className="popup__body u-padd--x--reset">
				{t("mybets:REUSE.MESSAGE", {
					bsn: reuseStore.reuseModalData?.betSlipNumber,
				})}
			</div>
			<div className="popup__footer u-padd--reset">
				<button
					id="close"
					className="at-slipReuseSecondaryBtn popup__btn popup__btn--secondary btn btn--med btn--primary--inverted"
					type="button"
					onClick={() => {
						reuseStore.closeReuseBetSlipModalBetDetails();
						store.onReuseClose();
					}}
				>
					{t<string>("COMMON.CANCEL")}
				</button>
				<button
					className="at-slipReusePrimaryBtn popup__btn popup__btn--primary btn btn--med btn--accent"
					type="submit"
					onClick={() => {
						reuseStore.reuseBetSlip();
						store.onReuseClose();
					}}
				>
					{t<string>("COMMON.YES")}
				</button>
			</div>
		</div>
	);
});
